<p-toast></p-toast>
<app-top-bar [topBarTitle]="'Skill Details'"></app-top-bar>
<div *ngIf="accessToSkillDetails && skill && !isLoading">
    <div class="skillDetailsContainer">
      <div class="columns toolbar">
        <div class="column1">
          <div class="overflow-ellipsis" tooltipPosition="bottom" pTooltip="{{ skill?.code }} {{ skill?.name }}" tooltipStyleClass="tooltip">
            <label class="skillCode">{{ skill?.code }}</label>
            <label class="skillName">{{ skill?.name }}</label>
          </div>
        </div>

        <div class="column4">
          <div class="btn" *ngIf="isEditSkillEnabled()">
            <p-button
              appPreventDoubleClick
              styleClass="p-button-outlined"
              id="editSkillButton"
              icon="fa fa-pen"
              iconPos="left"
              pTooltip="Edit Skill"
              tooltipPosition="left"
              (debounceClick)="editSkill()"
            ></p-button>
          </div>
          <div class="btn" *ngIf="skill?.isAddTrainingItemGroupButtonVisible">
            <p-button
              appPreventDoubleClick
              id="addTrainingItemsButton"
              icon="fa fa-plus"
              iconPos="left"
              pTooltip="Add Training Item(s)"
              tooltipPosition="left"
              (debounceClick)="openAddTrainingItems()"
            ></p-button>
          </div>
        </div>
      </div>

  <div class="bpt-main-content-container">
    <p-tabView [(activeIndex)]="activeIndex" (onChange)="onTabChange($event)">
      <p-tabPanel header="General">
        <p-fieldset legend="Skill Summary" [toggleable]="true">
          <div class="grid">
            <div class="col">
              <app-label labelText="Description"></app-label>
              <app-read-only [readonlyText]="skill?.description || ''"></app-read-only>
            </div>
            <div class="col">
              <app-label labelText="Training Criteria"></app-label>
              <app-read-only [readonlyText]="skill?.trainingCriteria || ''"></app-read-only>
            </div>
          </div>

          <div class="grid" *ngIf="skill?.eQMSScopes?.length">
            <div class="col">
              <app-label labelText="eQMS Scopes"></app-label>
              <div *ngFor="let scope of skill?.eQMSScopes" class="scope-item">
                <app-read-only [readonlyText]="scope"></app-read-only>
              </div>
            </div>
          </div>

          <div class="grid">
            <div class="col">
              <app-label labelText="Verification Required?"></app-label>
               <app-read-only [readonlyText]="skill?.verificationRequired ? 'Yes' : 'No'"></app-read-only>
            </div>
          </div>

          <div class="grid">
            <div class="col">
              <app-label labelText="Acknowledgement Required?"></app-label>
              <app-read-only [readonlyText]="skill?.acknowledgementRequired ? 'Yes' : 'No'"></app-read-only>
            </div>
          </div>

          <div class="grid">
            <div class="col">
              <app-label labelText="Is Active?"></app-label>
              <app-read-only [readonlyText]="skill?.isActive ? 'Yes' : 'No'"></app-read-only>
            </div>
          </div>
        </p-fieldset>
      </p-tabPanel>
      <p-tabPanel header="Linked Training Items">
        <ng-template pTemplate="content">
          <ng-container *ngIf="isTrainingItemsTabActive">
            <app-skill-training-items-list [skillCode]="skill?.code || ''" [isTrainingItemStatusUpdateEnabled]="!!skill?.skillAuthorizationFlag?.isTrainingItemStatusUpdateEnabled"></app-skill-training-items-list>
          </ng-container>
        </ng-template>
      </p-tabPanel>
      <p-tabPanel header="Audit Trail">
        <ng-template pTemplate="content">
          <ng-container *ngIf="isAuditTabActive">
            <ng-container *ngIf="!isAuditDataLoading; else auditLoading">
              <app-error *ngIf="auditLoadErrorMessage" [errorMessage]="auditLoadErrorMessage"></app-error>
              <app-skill-audit-trial *ngIf="!auditLoadErrorMessage" [auditTrailData]="auditTrailData"></app-skill-audit-trial>
            </ng-container>
            <ng-template #auditLoading>
              <app-spinner></app-spinner>
            </ng-template>
          </ng-container>
        </ng-template>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>
</div>
<app-skill-creation-slider
  *ngIf="isSkillSliderOpen"
  [isSkillSliderOpen]="isSkillSliderOpen"
  [isEditMode]="true"
  [skillDetailsData]="skill"
  (isSkillSliderActive)="closeSkillSlider($event)"
></app-skill-creation-slider>
<app-skill-training-item-slider
  *ngIf="isTrainingItemSliderOpen"
  [isTrainingItemSliderOpen]="isTrainingItemSliderOpen"
  (isTrainingItemSliderActive)="closeTrainingItemSlider($event)"
  [skillScopes]="skill?.eQMSScopeIds!"
  [skillCode]="skill?.code!"
></app-skill-training-item-slider>
<ng-container *ngIf="!(accessToSkillDetails && skill && !isLoading)">
    <app-error *ngIf="!isLoading" [errorMessage]="getSkillDetailsErrorMessage()"></app-error>
</ng-container>
